import { createInstance, setLogLevel, ReactSDKClient, enums } from '@optimizely/react-sdk';

import config from 'js/config/config';

import isElectron from './isElectron';

let optimizely: ReactSDKClient;

export default function getOptimizelyInstance(): ReactSDKClient {
  if (optimizely) return optimizely;

  const { OPTIMIZELY_SDK_KEY, OPTIMIZELY_LOG_LEVEL } = config;

  optimizely = createInstance({
    sdkKey: OPTIMIZELY_SDK_KEY
  });
  setLogLevel(OPTIMIZELY_LOG_LEVEL ?? enums.LOG_LEVEL.ERROR);
  return optimizely;
}

export function getApplication(): 'web' | 'electron' {
  return isElectron() ? 'electron' : 'web';
}

export function getApplicationVersion(): string | null {
  const application = getApplication();
  if (application === 'web') {
    return null;
  }
  return window.electron?.application.getVersion() || null;
}
